/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenameInstructionFileDto
 */
export interface RenameInstructionFileDto {
    /**
     * The file type to rename
     * @type {string}
     * @memberof RenameInstructionFileDto
     */
    fileType: RenameInstructionFileDtoFileTypeEnum;
    /**
     * New custom name for the file
     * @type {string}
     * @memberof RenameInstructionFileDto
     */
    customName: string;
}


/**
 * @export
 */
export const RenameInstructionFileDtoFileTypeEnum = {
    Txt: 'txt',
    Pdf: 'pdf'
} as const;
export type RenameInstructionFileDtoFileTypeEnum = typeof RenameInstructionFileDtoFileTypeEnum[keyof typeof RenameInstructionFileDtoFileTypeEnum];


/**
 * Check if a given object implements the RenameInstructionFileDto interface.
 */
export function instanceOfRenameInstructionFileDto(value: object): value is RenameInstructionFileDto {
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('customName' in value) || value['customName'] === undefined) return false;
    return true;
}

export function RenameInstructionFileDtoFromJSON(json: any): RenameInstructionFileDto {
    return RenameInstructionFileDtoFromJSONTyped(json, false);
}

export function RenameInstructionFileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenameInstructionFileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fileType': json['fileType'],
        'customName': json['customName'],
    };
}

export function RenameInstructionFileDtoToJSON(json: any): RenameInstructionFileDto {
    return RenameInstructionFileDtoToJSONTyped(json, false);
}

export function RenameInstructionFileDtoToJSONTyped(value?: RenameInstructionFileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileType': value['fileType'],
        'customName': value['customName'],
    };
}

